export default __webpack_public_path__ + "static/media/camera.b327a15e.svg";